import React from "react";

export const inputCls =
  "w-full rounded-lg bg-[#0e0f1a] border border-white/10 px-3.5 py-2.5 text-white text-sm focus:border-[#00ff87] focus:outline-none transition-colors";
export const labelCls = "block text-xs font-medium text-gray-400 mb-1.5";

const SeoFields = ({ seo, onChange }) => {
  const set = (k, v) => onChange({ ...seo, [k]: v });
  return (
    <div className="rounded-xl border border-[#00ff87]/15 bg-[#0a0a13] p-4 space-y-4">
      <h4 className="font-display font-semibold text-[#00ff87] text-sm">SEO Settings</h4>
      <div className="grid sm:grid-cols-2 gap-4">
        <div>
          <label className={labelCls}>Meta Title</label>
          <input className={inputCls} value={seo.metaTitle || ""} onChange={(e) => set("metaTitle", e.target.value)} placeholder="Online Cricket ID | DaddyAnna" />
        </div>
        <div>
          <label className={labelCls}>Meta Keywords</label>
          <input className={inputCls} value={seo.metaKeywords || ""} onChange={(e) => set("metaKeywords", e.target.value)} placeholder="cricket id, online cricket id, daddyanna" />
        </div>
      </div>
      <div>
        <label className={labelCls}>Meta Description</label>
        <textarea rows={2} className={inputCls} value={seo.metaDescription || ""} onChange={(e) => set("metaDescription", e.target.value)} placeholder="Short description for search engines" />
      </div>
      <div className="grid sm:grid-cols-2 gap-4">
        <div>
          <label className={labelCls}>OG Title</label>
          <input className={inputCls} value={seo.ogTitle || ""} onChange={(e) => set("ogTitle", e.target.value)} />
        </div>
        <div>
          <label className={labelCls}>OG Image URL</label>
          <input className={inputCls} value={seo.ogImage || ""} onChange={(e) => set("ogImage", e.target.value)} />
        </div>
      </div>
      <div>
        <label className={labelCls}>OG Description</label>
        <textarea rows={2} className={inputCls} value={seo.ogDescription || ""} onChange={(e) => set("ogDescription", e.target.value)} />
      </div>
    </div>
  );
};

export const emptySeo = { metaTitle: "", metaDescription: "", metaKeywords: "", ogTitle: "", ogDescription: "", ogImage: "" };
export const slugify = (s) => s.toLowerCase().trim().replace(/[^a-z0-9\s-]/g, "").replace(/\s+/g, "-").replace(/-+/g, "-");

export default SeoFields;
